<template>
  <div :class="classA">
    <el-row class="page-box">
      <slot></slot>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paging.page_num"
        :page-sizes="pageSizes"
        :page-size="paging.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paging.total"
      >
      </el-pagination>
    </el-row>
    <!-- <dialog-driver ref="dialogDriver" @upup="back"></dialog-driver> -->
  </div>
</template>
<script>
// import DialogDriver from "@/components/vehicle/dialog/dialog-driver"
export default {
  data() {
    return {
      pageSizes: this.sizes ? this.sizes : [10, 20, 30, 50],
      classA: "page-boxs",
    };
  },
  methods: {
    handleSizeChange(size) {
      this.paging.page_size = size;
      this.paging.page_num = 1;
      this.$emit("upup", this.paging);
    },
    handleCurrentChange(page_num) {
      this.paging.page_num = page_num;
      this.$emit("upup", this.paging);
    },
    // handleScroll () {
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   //变量windowHeight是可视区的高度
    //   var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   //变量scrollHeight是滚动条的总高度
    //   var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    //   //滚动条到底部的条件
    //   let sum = scrollHeight - (scrollTop + windowHeight)
    //   if (scrollTop > 0) {
    //     if (sum > 200) {
    //       this.classA = 'main-bd'
    //     } else {
    //       this.classA = 'main-bdd'
    //     }
    //   }
    // },
  },
  created() {
    if (this.size) {
      this.pageSizes.push(this.size);
    }
    if (this.sizes) {
      this.pageSizes = this.sizes;
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll, true)
  },
  props: {
    paging: {
      type: Object,
    },
    size: {
      type: Number,
    },
    sizes: {
      //选择页码数
      type: Array,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/paging/paging-default.vue